export const DIAGNOSTICO_LOAD = "DIAGNOSTICO_LOAD";
export const KPI_LOAD = "KPI_LOAD";
export const RUPTURA_LOAD = "RUPTURA_LOAD";
export const RUPTURA_DETALHE = "RUPTURA_DETALHE";
export const AVALIACAO_LOAD = "AVALIACAO_LOAD";
export const TEMPO_MEDIO_LOAD = "TEMPO_MEDIO_LOAD";
export const TICKET_MEDIO_LOAD = "TICKET_MEDIO_LOAD";
